import { MessageCircle, Music, Video, type LucideProps } from 'lucide-react'
import type { SetPostSummary } from '../hooks/useSetPosts'

/** Video when the feed has a YouTube post, music for other media, else a comment bubble. */
export function FeedIcon({ summary, ...props }: LucideProps & { summary: SetPostSummary | undefined }) {
  if (summary?.providers.has('youtube')) return <Video {...props} />
  if ((summary?.providers.size ?? 0) > 0) return <Music {...props} />
  return <MessageCircle {...props} />
}

/** Post-count pill on a set/lineup card that opens its feed. */
export function FeedBadge({
  summary,
  onOpen,
  ariaLabel,
}: {
  summary: SetPostSummary | undefined
  onOpen: () => void
  ariaLabel: string
}) {
  const count = summary?.count ?? 0
  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation()
        onOpen()
      }}
      aria-label={ariaLabel}
      className={
        count > 0
          ? 'flex items-center gap-0.5 rounded-full bg-black/50 px-1.5 py-0.5 text-[10px] font-semibold text-on-image cursor-pointer hover:bg-black/70'
          : 'flex items-center rounded-full p-1 -mr-1 text-on-image-muted cursor-pointer hover:text-on-image'
      }
    >
      <FeedIcon summary={summary} className="size-3.5" />
      {count > 0 && count}
    </button>
  )
}
